jQuery(document).ready(function () {
    /*****
     * smartresize when resize screen
     *****/
    _window.smartresize(function () {
        /* re-calc viewport Width & Height */
        viewportW = _window.width();
        viewportH = _window.height();
    });

    /* menu smp */
    var header_scroll_class = '_small';

    /* header small */
    jQuery(window).on('scroll', function (e) {
        if (jQuery(window).scrollTop() > 100)
            jQuery('#header').addClass(header_scroll_class);
        else jQuery('#header').removeClass(header_scroll_class);
    });

    /*! scroll to top !*/
    jQuery('body').toTopButton({
        imagePath: assets_path + 'images/icons',
        arrowType: 'temp_icon',
        margin: 2,
        size: is_smp ? 2 : 4,
        backgroundColor: '#36A100',
        linkClasses: [' scroll_totop'],
        mobileHide: 0
    });

    /*! zoom img on SMP !*/
    var smp_zoom = jQuery('.smp_zoom');
    if (smp_zoom.length > 0 && viewportW <= viewportSMP) {
        smp_zoom.each(function () {
            jQuery(this).wrap('<a data-fancybox href="' + jQuery(this).attr('src') + '"></a>');
        });
    }

    /* check element in view */
    var in_view = jQuery('[class*="inview-"]');
    if (in_view.length > 0) {
        in_view.on('inview', function (event, isInView) {
            if (isInView)
                jQuery(this).addClass('inview-active');
        });
    }

    /* odometer */
    var inview_odometer = jQuery('.odometer');
    if (inview_odometer.length > 0) {
        inview_odometer.on('inview', function (event, isInView) {
            if (isInView) {
                var odo_value = jQuery(this).data('odo');
                if (odo_value !== undefined)
                    jQuery(this).html(odo_value);
            }
        });
    }

    /* fancybox */
    Fancybox.bind('[data-fancybox=""]', {
        // Your custom options
    });

    Fancybox.bind('[data-fancybox="single"]', {
        groupAttr: false,
    });

    /* main visual */
    setTimeout(function () {
        var main_visual = jQuery('.main_visualbox__banner');
        if (main_visual.length > 0) {
            // background image
            var mainvisual_image = is_smp ? main_visual.data('imgsmp') : main_visual.data('imgpc');
            main_visual.css('background-image', 'url(' + mainvisual_image + ')');
        }
    }, 500);

    /* common navi anchor */
    var common_navi_anchor = jQuery('.common_navi_anchor');
    if (common_navi_anchor.length > 0) {
        _heightline({
            itemClsName: '.common_navi_anchor a',
            itemPerRow: 2,
            device: 'smp'
        });
    }

    /* title01 icon dotted */
    var title01 = jQuery('.title01');
    if (title01.length > 0) {
        title01.each(function () {
            jQuery(this).prepend('<i class="_dot"></i>');
        });
    }

    /* recruit_top_title */
    var recruit_title = jQuery('.recruit_top_title');
    if (recruit_title.length > 0) {
        recruit_title.each(function () {
            jQuery(this).wrapInner('<span class="_bg"></span>');
        });
    }

    if (is_smp) {
        /* menu smp */
        var menu_smp = jQuery('.hamburger');
        menu_smp.on('click', function () {
            jQuery(this).toggleClass('is-active');
            jQuery('#header').toggleClass('is-open');
            jQuery('.header_box').slideToggle(300);
        });

        jQuery('.header_navi .navi .trigger').click(function () {
            if (jQuery(this).next('.header_navi_sub_box').length > 0) {
                jQuery(this).parents('li').toggleClass('navisub_active');
                jQuery(this).next('.header_navi_sub_box').stop(true, true).slideToggle(300);
                return false;
            }
        });

        jQuery('.header_navi_sub_box li').click(function () {
            jQuery('.hamburger').toggleClass('is-active');
            jQuery('#header').toggleClass('is-open');
            jQuery('.header_box').slideToggle(300);
        });
    }
    jQuery(window).scroll(function () {
        var footerTop = jQuery('#footer').offset().top;
        var scrollTop = jQuery(window).scrollTop();
        var viewportHeight = jQuery(window).height();

        if (footerTop <= scrollTop + viewportHeight) {
            jQuery('#footer').addClass('temp_recruit_linkfix');
        } else {
            jQuery('#footer').removeClass('temp_recruit_linkfix');
        }
    });

    /*recruit template*/
    if (is_smp) {
        jQuery('.headerRecruit_navi .has_children a').click(function () {
            if (jQuery(this).next('.headerRecruit_sub').length > 0) {
                jQuery(this).parent().toggleClass('navi_active');
                jQuery(this).next('.headerRecruit_sub').stop(true, true).slideToggle(300);
                return false;
            }
        });

        jQuery('.footerRecruit_box_nav_item  .has_children').click(function () {
            if (jQuery(this).next('.footerRecruit_sub').length > 0) {
                jQuery(this).parents('.footerRecruit_box_nav_item ').toggleClass('navisub_active');
                jQuery(this).next('.footerRecruit_sub').stop(true, true).slideToggle(300);
                return false;
            }
        });
    } else {
        header_recruit_navi = jQuery('.headerRecruit_navi .navi .has_children');
        headerRecruit = jQuery('.headerRecruit');

        header_recruit_navi.hover(function () {
            jQuery(this).children('.headerRecruit_sub').stop().slideDown(200);
            jQuery(this).addClass('open');
            headerRecruit.addClass('nav_drop');
        }, function () {
            jQuery(this).children('.headerRecruit_sub').stop().slideUp(200);
            jQuery(this).removeClass('open');
            headerRecruit.removeClass('nav_drop');
        });
    }

    jQuery('a[href="#"]').on('click', function(){
        if(!jQuery(this).parent().hasClass('_link'))
            return false;
    });

});

(function ($) {

    /** *******************************************************************************
     * 閭梧勹濶ｲ縺御ｼｸ縺ｳ縺ｦ蜃ｺ迴ｾ
     */
    function BgFadeAnime() {
        $('.bgLRendTrg').each(function () {
            var elemPos = $(this).offset().top - 50;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll >= elemPos - windowHeight) {
                $(this).addClass('bgLRextend');
            } else {
                //$(this).removeClass('bgLRextend');
            }
        });

        $('.bginnerTrg').each(function () {
            var elemPos = $(this).offset().top - 50;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll >= elemPos - windowHeight) {
                $(this).addClass('bgappear');
            } else {
                //$(this).removeClass('bgappear');
            }
        });
    }

    $(window).scroll(function () {
        BgFadeAnime();
    });

    $(window).on('load', function () {
        BgFadeAnime();
    });

})(jQuery);